export const getTag = (tagId) => ({ tags }) =>
  tags.tagsList.find(({ id }) => id === tagId);